import { Injectable } from '@angular/core';
import { ReplaySubject, Subject } from 'rxjs';
import { MenuItem } from 'primeng/api';

@Injectable({
  providedIn: 'root'
})
export class BannerLocalService {

  constructor() { }

  private itemsSource: Subject<MenuItem[]> = new ReplaySubject(null);

  itemsHandler = this.itemsSource.asObservable();

  setItems(items: any): any {
    this.itemsSource.next(items);
  }
}
